import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RRBootstrapModule } from '../bootstrap/bootstrap.module';
import { RRSharedModule } from '../shared-module/shared.module';
import { StepperComponent } from './components/stepper/stepper.component';

@NgModule({
  declarations: [StepperComponent],
  imports: [RRSharedModule, RRBootstrapModule, FormsModule],
  exports: [StepperComponent],
})
export class RRStepperModule {}
